import { motion } from "framer-motion";
import { MANIFESTO } from "../data/content";

const EASE = [0.22, 1, 0.36, 1];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="md:sticky md:top-32">
            <p className="text-[11px] font-mono tracking-[0.25em] uppercase text-stone-500">
              01 // Prologue
            </p>
            <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-normal tracking-tight text-ivory">
              The Manifesto
            </h2>
            <p className="mt-4 text-sm font-light text-stone-400 leading-relaxed max-w-xs">
              Three convictions that shape every frame we release into the world.
            </p>
          </div>
        </div>
        <div className="md:col-span-8">
          {MANIFESTO.map((chapter, i) => (
            <motion.article
              key={chapter.number}
              data-testid={`manifesto-chapter-${chapter.number}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.08, ease: EASE }}
              className="group border-t border-white/10 py-10 first:pt-0 md:first:pt-10"
            >
              <span className="font-serif italic text-3xl text-gold/70">{chapter.number}</span>
              <h3 className="mt-3 font-serif text-xl sm:text-2xl text-ivory group-hover:text-champagne transition-colors duration-500">
                {chapter.title}
              </h3>
              <p className="mt-3 max-w-xl text-sm sm:text-base font-light leading-relaxed text-stone-400">
                {chapter.text}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
